import type { FaireProductEntity } from "../../entity_types/product";

export const p_bua5tpa8sy: FaireProductEntity = {
  token: "p_bua5tpa8sy",
  type: "product",
  name: "Kauai Surfer Anklet, Adjustable Beaded Ankle Bracelet",
  brandName: "Pineapple Island",
  imageUrl:
    "https://cdn.faire.com/fastly/7f8e3e2d6fefc99639a253679b61c3d626caa41e5dbe1a2c3394559b15533b13.jpeg",
  priceDollars: 3.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/0193d1d2c59385c27107b0c57a7aed1727f42362d6a757e5c0b72e25554aa2b7.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
